import { DatePicker, Input, Pagination, Radio, Select, Table } from "antd";
import dayjs from "dayjs";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { fetchAccountStatement } from '../../redux/slice/accountStatement/accountStatementSlice';
import Loader from "components/loader";
import { useLocation, useNavigate } from "react-router-dom";


const AccountStatement = () => {
    const { state } = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const { data, loading, error } = useSelector((state) => state.accountStatement);
    const { isAuthenticated } = useSelector((state) => state.authSlice);
    const profileData = useSelector((state) => state.authSlice.profileData);
    const [selectedType, setSelectedType] = useState('All');
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const [filteredData, setFilteredData] = useState();

    const [fromDate, setFromDate] = useState(dayjs().subtract(1, 'day'));
    const [toDate, setToDate] = useState(dayjs());


    // const paginatedData = data && data?.data.slice(startIndex, endIndex);
    const paginatedData = filteredData?.slice(startIndex, endIndex);

    const locale = {
        emptyText: (
            <h5 className="!text-[#c7313f] !font-bold !m-0 text-[1.2rem] leading-[1.2]">No data.</h5>
        )
    }

    const handlePageSizeChange = (e) => {
        setPageSize(e);
        setCurrent(1);
    };
    // console.log('state:', state)

    const columns = [
        {
            title: 'S.No.',
            dataIndex: 'index',
            render: (_, record, index) => (
                <span>{(index + 1)}</span>
            )
        },
        {
            title: 'Date',
            dataIndex: 'date',
            width: '12%',
            render: (_, record) => (
                <span>{new Date(record?.createdAt).toLocaleString()}</span>
            ),
        },
        {
            title: 'Description',
            dataIndex: 'remark',
            render: (_, record) => (
                <span className={`${record?.match_id && 'text-[#5a738e] cursor-pointer'}`}
                    onClick={() => {
                        record?.match_id && navigate(`/matchDetailList/${record?.match_id}/${record?.selection_id}`);
                    }}
                >{`${record?.event_name} / ${record?.market_name} / ${record?.place_name}` || '-'}</span>
            )
        },
        {
            title: 'Credit',
            dataIndex: 'credit',
            align: 'right',
            width: '12%',
            render: (_, record) => (
                <span className='text-[#508d0e] '>{record?.amount > 0 ? Number(record?.amount).toFixed(2) : '-'}</span>

                // <span className='text-[#508d0e] '>{(record?.type == 'Settlement' || record?.type == 'WCO_CASINO' || record?.type == 'Free Chip') && record?.transaction_type == 'Credit' ? record?.amount ? Number(record?.amount).toFixed(2) : '-' : record?.credit ? Number(record?.credit).toFixed(2) : '-' || '-'}</span>
            ),
        },
        {
            title: 'Debit',
            dataIndex: 'debit',
            align: 'right',
            width: '12%',
            render: (_, record) => (
                // <span className=' text-[#d50000] '>{record?.debit || '-'}</span>
                <span className='text-[#d50000] '>{record?.amount < 0 ? Number(record?.amount).toFixed(2) : '-'}</span>

                // <span className='text-[#d50000] '>{(record?.type == 'Settlement' || record?.type == 'WCO_CASINO' || record?.type == 'Free Chip') && record?.transaction_type == 'Debit' ? record?.amount ? Number(record?.amount).toFixed(2) : '-' : record?.debit ? Number(record?.debit).toFixed(2) : '-' || '-'}</span>
            ),
        },
        // {
        //     title: 'Commission',
        //     dataIndex: 'commission	',
        //     align: 'right',
        //     width: '12%',
        //     render: (_, record) => (
        //         <span className=' text-[#d50000] '>{record?.commission}</span>
        //     ),
        // },
        {
            title: 'Balance',
            dataIndex: 'balance',
            align: 'right',
            width: '12%',
            render: (_, record) => (
                <span className=' text-[#508d0e]'>{record?.balance ? Number(record?.balance).toFixed(2) : '-'}</span>
            ),
        },
        // {
        //     title: 'Remarks',
        //     dataIndex: 'remarks',
        //     render: (_, record) => (
        //         <span className=' text-[#212529]  '>{record?.remarks || '-'}</span>
        //     ),
        // },
    ];
    useEffect(() => {
        const fetchData = () => {
            const params = {
                user_id: state?.user_id,
                type: selectedType,
                from_date: fromDate.format("YYYY-MM-DD"),
                to_date: toDate.format("YYYY-MM-DD"),
                search: "",
                is_default: false
            };

            if (isAuthenticated) {
                dispatch(fetchAccountStatement(params));
            }
        };

        fetchData();
    }, [dispatch]);

    const handleGoClick = () => {
        const params = {
            user_id: state?.user_id,
            type: selectedType,
            from_date: fromDate.format("YYYY-MM-DD"),
            to_date: toDate.format("YYYY-MM-DD"),
            search: "",
            is_default: false
        };
        if (isAuthenticated) {
            dispatch(fetchAccountStatement(params));
        }
    };

    const handleResetClick = () => {
        setSelectedType('All');
        setFromDate(dayjs().subtract(1, 'day'));
        setToDate(dayjs());
    };

    useEffect(() => {
        if (data) {
            setFilteredData(data?.data)
        }
    }, [data])

    const handleSearch = (value, dataIndex) => {

        if (!value) {
            setFilteredData(data?.data)
            return;
        }

        const filtered = data?.data.filter(item => {
            return Array.isArray(dataIndex)
                ? dataIndex.some(key => item[key]?.toString().toLowerCase().includes(value.toLowerCase()))
                : item[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase());
        });

        // const filtered = data.length ? data.filter(item => item[dataIndex].toString().toLowerCase().includes(value.toLowerCase())) : [];
        setFilteredData(filtered);
        setCurrent(1); // Reset to the first page after a search
    };


    return (
        <>
            {
                loading && <Loader />
            }
            <div className='relative min-w-full'>
                <div className='grid grid-cols-12 lg:px-[6px] mt-[.5rem] lg:mt-0'>
                    <div className='col-span-12'>
                        <div className='relative w-full'>
                            <p className=' bg-[linear-gradient(#022c43,_#18b0c8)] text-[#fff] text-[14px] font-bold h-[28px] leading-[19px] m-0 pl-[7px] pr-[10px] py-[6px] capitalize'>Account Statement</p>
                        </div>
                        <div className="bg-[#fff] text-[#000] mb-[10px] min-h-[500px] w-full">
                            <div className="grid grid-cols-12">
                                <div className="col-span-12 !mt-[.5rem] relative !px-[6px] !py-[0]">
                                    <Radio.Group
                                        name="radiogroup"
                                        value={selectedType}
                                        onChange={(e) => setSelectedType(e.target.value)}
                                        options={[
                                            {
                                                value: 'All',
                                                label: 'All',
                                            },
                                            {
                                                value: 'Free Chip',
                                                label: 'Deposit/Withdraw',
                                            },
                                            {
                                                value: 'PL',
                                                label: 'Sports P/L',
                                            },
                                            {
                                                value: 'Casino PL',
                                                label: 'Casino P/L',
                                            },
                                            {
                                                value: 'Settlement',
                                                label: 'Settlement',
                                            },
                                        ]}
                                    />
                                </div>
                                <div className="col-span-12 lg:col-span-2 !mt-[.5rem] relative !px-[6px] !py-[0]">
                                    <div class="text-[15px] relative mb-4">
                                        <DatePicker
                                            inputReadOnly
                                            className="!w-full"
                                            onChange={(date) => setFromDate(date)}
                                            value={fromDate}
                                            allowClear={false}
                                            format="DD/MM/YYYY"
                                        />
                                    </div>
                                </div>
                                <div className="col-span-12 lg:col-span-2 !mt-[.5rem] relative !px-[6px] !py-[0]">
                                    <div class="text-[15px] relative mb-4">
                                        <DatePicker
                                            inputReadOnly
                                            className="!w-full"
                                            onChange={(date) => setToDate(date)}
                                            value={toDate}
                                            allowClear={false}
                                            format="DD/MM/YYYY"
                                        />
                                    </div>
                                </div>
                                <div className="col-span-12 lg:col-span-2 !mb-4 !mt-[.5rem] relative w-full !px-[6px] !py-[0]">
                                    <div class="inline-flex relative align-middle" role="group" aria-label="Basic example" id="divpagecount">
                                        <button type="button" class="rounded-br-none rounded-tr-none flex-auto relative cursor-pointer bg-[linear-gradient(-180deg,_#5ecbdd,_#146578)] border-[1px] border-[solid] border-[#146578] text-[#fff] rounded-[3px] text-[14px] outline-[none] px-[20px] py-[5px] text-center inline-block font-normal leading-normal [transition:color_.15sease-in-out,_background-color_.15sease-in-out,_border-color_.15sease-in-out,_box-shadow_.15sease-in-out]" onClick={handleGoClick}>Go</button>
                                        <button type="button" class="rounded-bl-none rounded-tl-none flex-auto relative cursor-pointer bg-[linear-gradient(-180deg,_#5ecbdd,_#146578)] border-[1px] border-[solid] border-[#146578] text-[#fff] rounded-[3px] text-[14px] outline-[none] px-[20px] py-[5px] text-center inline-block font-normal leading-normal [transition:color_.15sease-in-out,_background-color_.15sease-in-out,_border-color_.15sease-in-out,_box-shadow_.15sease-in-out] ml-[.25rem]" onClick={handleResetClick}>Reset</button>
                                    </div>
                                </div>
                                {/* <div className="col-span-12 lg:col-span-2 !mt-[.5rem] relative !px-[6px] !py-[0]">
                                <table class="w-full whitespace-nowrap">
                                    <tbody>
                                        <tr class="w-full">
                                            <td className="border-[1px] border-[solid] border-[#dee2e6] p-[.3rem]">
                                                <span class="!text-[14px] !inline">Closing Balance &nbsp;&nbsp; </span>
                                            </td>
                                            <td className="border-[1px] border-[solid] border-[#dee2e6] p-[.3rem] text-right">
                                                <span class="d-inline font-14">2385.10</span>
                                            </td>
                                        </tr>
                                        <tr class="w-full">
                                            <td className="border-[1px] border-[solid] border-[#dee2e6] p-[.3rem]">
                                                <span class="d-inline font-14">Opening Balance </span>
                                            </td>
                                            <td className="border-[1px] border-[solid] border-[#dee2e6] p-[.3rem] text-right">
                                                <span class="d-inline font-14">2285.10</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div> */}
                            </div>

                            <div className='col-span-12'>
                                <Table
                                    title={() => (
                                        <div className='grid grid-cols-12 my-[.5rem]'>
                                            <div className='col-span-12 lg:col-span-6 flex items-center mt-[.25rem] justify-start '>
                                                <div className=' flex float-left'>
                                                    <div className="text-[15px] relative flex gap-2 w-[200px]">
                                                        Search:
                                                        <Input
                                                            onChange={e => handleSearch(e.target.value, ['remarks', 'amount', 'debit', 'balance'])}
                                                            className="!text-[12px] h-[30px] pl-[2px] pr-[5px] py-[5px] bg-clip-padding !bg-[#fff] border-[1px] border-[solid] !border-[#ced4da] rounded-[.25rem] !text-[#495057] block font-normal leading-normal [transition:border-color_.15sease-in-out,_box-shadow_.15sease-in-out] w-full"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-span-12 lg:col-span-6 flex items-center justify-end  '>
                                                <div className='  p-[.5rem] lg:p-[0px]'>
                                                    <span class="text-[#000] float-right text-[14px] mr-[5px] mt-[4px] !ml-[.5rem] !inline2">entries</span>
                                                    <div className="text-[15px] relative float-right">
                                                        <Select defaultValue={10} onChange={handlePageSizeChange} className='pagesize-select mx-[5px] '>
                                                            <Select.Option value={10}>10</Select.Option>
                                                            <Select.Option value={25}>25</Select.Option>
                                                            <Select.Option value={50}>50</Select.Option>
                                                            <Select.Option value={100}>100</Select.Option>
                                                        </Select>
                                                    </div>
                                                    <span class="text-[#000] float-right text-[14px] mr-[5px] mt-[4px] !inline">Show</span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    locale={locale}
                                    columns={columns}
                                    className='px-[.5rem] account-statement'
                                    bordered
                                    dataSource={paginatedData}
                                    pagination={false}
                                />
                                <div className='grid grid-cols-12 items-center py-[1rem] px-[.5rem]'>
                                    <div className='col-span-12 lg:col-span-6  '>
                                        Showing {startIndex + 1} - {endIndex} of {filteredData && filteredData.length} entries
                                    </div>
                                    <div className='col-span-12 lg:col-span-6 flex items-center justify-end  pt-[1rem] lg:pt-[0px] lg:mt-[0rem]'>
                                        <Pagination
                                            current={current}
                                            pageSize={pageSize}
                                            total={filteredData && filteredData.length}
                                            onChange={(page) => setCurrent(page)}
                                            itemRender={(page, type, originalElement) => {
                                                if (type === 'prev') {
                                                    return <button type='button' className='!cursor-pointer'>Prev</button>;
                                                }
                                                if (type === 'page') {
                                                    return null;
                                                }
                                                if (type === 'next') {
                                                    return <button type='button' className='!cursor-pointer'>Next</button>;
                                                }
                                                return originalElement;
                                            }}
                                            showSizeChanger={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div >

                </div >
            </div >
        </>
    )
}
export default AccountStatement